import './viewerVideo.scss'
import React, { Component } from 'react';
import AiComplianceIcon from '../aiComplianceIcon/aiComplianceIcon';

const ViewerVideo = ({ aiCompliance, source, name }) => {
    return (
        <div className="b-viewer video">
            <AiComplianceIcon aiCompliance={aiCompliance} />
            <video controls src={source} data-testid={name} />
        </div>
    );
};

export default ViewerVideo;
